import { createFileRoute } from '@tanstack/react-router';
import { ReviewScreen } from '../../screens/Review';

export const Route = createFileRoute('/tasks/review')({
  component: ReviewScreen,
});
